import React, { useState, useEffect } from "react";
import { reservasAPI } from "../../utils/funcionesAPI";
import { manejadorDeRespuesta, mostrarMes } from "../../utils/Tools";
import ListadoReservas from "./ListadoReservas";
import Filtros from "./Filtros";
import LoaderFormal from "../Global/LoaderFormal";

const MisReservas = (props) => {
  const { history } = props;
  const [reservas, setReservas] = useState([]);
  const [reservasFiltradas, setReservasFiltradas] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");

  if (!token && !user) {
    history.push("/login");
  }

  const traerReservasPorUsuario = (fecha = null) => {
    const data = JSON.stringify({
      peticion: "traerReservasPorCliente",
      token,
      fecha,
    });

    setLoaded(true);
    reservasAPI(data).then((respuesta) => {
      setLoaded(false);
      if (manejadorDeRespuesta(props, respuesta)) {
        setReservas(respuesta.data);
        setReservasFiltradas(respuesta.data);
      }
    });
  };

  useEffect(() => {
    traerReservasPorUsuario();
  }, [token]);

  const handleFiltrarPorEstadoClick = (e) => {
    //let reservas = reservas.slice();
    let reservasFiltered = [];

    switch (e.value) {
      case "0":
        setReservasFiltradas(reservas);
        break;
      case "1":
        reservasFiltered = reservas.filter(
          (unaReserva) =>
            unaReserva.estado >= Number(e.value) && unaReserva.estado < 9
        );
        setReservasFiltradas(reservasFiltered);
        break;
      case "9":
        reservasFiltered = reservas.filter(
          (unaReserva) => unaReserva.estado === Number(e.value)
        );
        setReservasFiltradas(reservasFiltered);
        break;
      default:
    }
  };

  useEffect(() => {
    handleFiltrarPorEstadoClick({ value: "1" });
  }, [reservas]);

  const handleFiltrarPorMesClick = (e) => {
    //let reservas = reservas.slice();
    //let reservasFiltradas = [];

    if (e.value === "0") {
      setReservasFiltradas(reservas);
      return;
    }

    const reservasFiltered = reservas.filter(
      (unaReserva) => e.value === mostrarMes(unaReserva.charter.fechaSalida)
    );

    setReservasFiltradas(reservasFiltered);
  };

  const handleFiltrarPorDestinoClick = (e) => {
    //let reservas = reservas.slice();
    //let reservasFiltradas = [];

    if (e.value === "0") {
      setReservasFiltradas(reservas);
      return;
    }

    const reservasFiltered = reservas.filter(
      (unaReserva) => e.value === unaReserva.producto.destino.idDestino
    );

    setReservasFiltradas(reservasFiltered);
  };

  return (
    <section className="reservas">
      <div className="container-fluid">
        <div className="row show-results col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h1 className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            Reservas ({reservasFiltradas.length})
          </h1>
          <Filtros
            onFiltrarPorEstado={handleFiltrarPorEstadoClick}
            onFiltrarPorMes={handleFiltrarPorMesClick}
            onFiltrarPorDestino={handleFiltrarPorDestinoClick}
            onPaqueteClick={traerReservasPorUsuario}
          />
          <LoaderFormal loaded={loaded} mensaje="Buscando Reservas..." />
          <ListadoReservas
            reservas={reservasFiltradas}
            onClickBotonFactura={traerReservasPorUsuario}
          />
        </div>
      </div>
    </section>
  );
};

export default MisReservas;
/*
  const traerReservasCDRPorUsuario = () => {
    const data = JSON.stringify({
      peticion: "traerReservasCDRPorCliente",
      token: token,
    });
    setLoaded(true);
    reservasAPI(data).then((respuesta) => {
      setLoaded(false);
      if (manejadorDeRespuesta(props, respuesta)) {
        setReservas(respuesta.data);
        setReservasFiltradas(respuesta.data);
        handleFiltrarPorEstadoClick({ value: "1" });
      }
    });
  };
*/



// WEBPACK FOOTER //
// ./src/components/MisReservas/index.js